import VModel from '@/app-core/mixins/vModel'
import Translatable from '@/app-core/mixins/translatable'
import CartCommon from '@/app-core/mixins/cart/cartCommon'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'

export default {
  name      : 'SelectPaymentMethod',
  components: {},
  directives: {},
  mixins    : [Translatable, VModel, CartCommon],
  props     : {
    title: {
      type   : String,
      default: 'Payment Details'
    }
  },
  dataStore: {
    AppCart    : 'App.Cart',
    AppPayments: 'App.Payments'
  },
  data() {
    return {}
  },
  computed: {
    paymentMethods() {
      return this.AppPayments || []
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase
  }
}
